import ko from '@tko/build.knockout';
import _ from 'lodash';
import Vue from 'vue';
import vuetify from '../../../../plugins/vuetify';
import MenuIcons from '../../../../app/helpers/menu-icons';
import OrgRegistration from '../../components/orgRegistration/orgRegistration.vue';
import templateMarkup from 'raw-loader!./org-registration.html';

class OrgRegistrationView {
    constructor(params) {
        let self = this;

        let email = ko.unwrap(params.route()).email;
        let token = ko.unwrap(params.route()).token;

        self.vueOrgRegistration = new Vue({
            el: '#vueOrgRegistration',
            vuetify,
            render: h => h(OrgRegistration, { props: { email, token } })
        });
    }

    dispose() {
        let self = this;
        if (self.vueOrgRegistration) {
            self.vueOrgRegistration.$destroy();
            self.vueOrgRegistration.$el.parentNode.removeChild(self.vueOrgRegistration.$el);
        }
    }
}

ko.components.register('org-registration-view', { template: templateMarkup, viewModel: OrgRegistrationView });

export default { template: templateMarkup, viewModel: OrgRegistrationView }
